export const salutationsMasters: string[] = ['Mr.', 'Ms.', 'M/S.', 'Mrs.'];
export const applicantStatusMasters: { [key: string]: string } = {
  Individual: 'Individual (Resident)',
  // NRI: 'Individual (Non-Resident)',
  NRE: 'Individual (NRI-NRE)',
  NRO: 'Individual (NRI-NRO)',
  "Non-Individual": "Non-Individual"
};
export const personLDetailsStatusMasters: { [key: string]: string } = {
  Individual: 'Individual (Resident)',
  // NRI: 'Individual (Non-Resident)',
  NRE: 'Individual (NRI-NRE)',
  NRO: 'Individual (NRI-NRO)',
};
export const minorOnboardingSubTypes: { [key: string]: string } = {
  Individual: 'Individual (Resident)',
  // NRI: 'Individual (Non-Resident)',
  // NRE: 'Individual (NRI-NRE)',
  NRO: 'Individual (NRI-NRO)',
};
export const personalDetailsStatusMasterResident: { [key: string]: string } = {
  Individual: 'Individual (Resident)',
}
export const personalDetailsStatusMasterNRI: { [key: string]: string } = {
  NRE: 'Individual (NRI-NRE)',
  NRO: 'Individual (NRI-NRO)',
}
export const onboardingTypeMasters: { [key: string]: string } = {
  normal: 'Normal',
  minor: 'Minor',
};
export const nationalitiesMasters: string[] = ['Indian', 'Others'];

// 1 lakh = 0.1 million (MIL)
// 1 crore = 10 million (MIL) or 0.01 billion (BIL)
export const grossAnnualMasters = (locale: string): Array<{ key: string; value: string }> => {
  if (locale === "en-IN") {
    return [
      { key: "Below 1 lakh", value: 'BELOW 1 LAC' },
      { key: "1-5 lakhs", value: '1-5 LAC' },
      { key: "5-10 lakhs", value: '5-10 LACS' },
      { key: "10-25 lakhs", value: '10-25 LACS' },
      { key: '>25 lakhs - 1 crore', value: '>25 LACS - 1 CRORE' },
      { key: '> 1 crore', value: '> 1 CRORE' },
    ]
  } else {
    return [
      { "key": "Below 0.1 mil", "value": "BELOW 0.1 MIL" },
      { "key": "0.1-0.5 mil", "value": "0.1-0.5 MIL" },
      { "key": "0.5-1 mil", "value": "0.5-1 MIL" },
      { "key": "1-2.5 mils", "value": "1-2.5 MILS" },
      { "key": ">2.5 mils - 10 mils", "value": ">2.5 MILS - 10 MILS" },
      { "key": "> 10 mils", "value": "> 10 MILS" }
    ]
  }
}

export const PEPsMasters: string[] = ['I am PEP', 'I am Related to PEP', 'Not Applicable'];

export const addressTypesMasters: string[] = [
  'Resident/Business',
  'Resident',
  'Business',
  'Registered Office',
  'Unspecified',
];

export const genderMasters: string[] = ['Male', 'Female', 'Others'];

export const maritalMasters: string[] = ['Single', 'Married', 'Others'];

export const citizenshipMasters: string[] = ['Indian', 'NRI', 'Others'];;

export const occupationDetailsMasters: string[] = [
  'Agriculturist',
  'Business',
  'Doctor',
  'Housewife',
  'Professional',
  'Retired',
  'Service',
  'Student',
  'Others',
];

export const branchMasters: string[] = [
  'Branch_1',
  'Branch_2',
  'Branch_3',
  'Branch_4',
  'Branch_5',
];

export const businessUnitMasters: string[] = [
  'Business_Unit_1',
  'Business_Unit_2',
  'Business_Unit_3',
  'Business_Unit_4',
  'Business_Unit_5',
];

export const deemedOvdValue: { [key: string]: string } = {
  'true': 'Yes',
  'false': 'No',
};

export const dndValue: { [key: string]: string } = {
  'false': 'No',
  'serviceCall': 'Service Call',
  'promotionalCalls': 'Promotional Calls',
  'emailCommunications': 'Email Communications',
  'mobileCommunication': 'Mobile Communication',
  'all': 'All',
  // Service call /Promotional calls/email communications/All/Mobile communication
};

export const BseStartCreationOptions: { [key: string]: string } = {
  'true': 'Yes',
  'false': 'No',
};

export const HeadOfFamily: { [key: string]: string } = {
  'true': 'Yes',
  'false': 'No',
};

export const TataGroup: { [key: string]: string } = {
  'true': 'Yes',
  'false': 'No',
};

export const AmlCheck: { [key: string]: string } = {
  'true': 'Yes',
  'false': 'No',
};

export const Divident_GrowthFilter_Mapping: { [key: string]: string } = {
  'divident_reinvestment': 'Y',
  'divident_payout': 'N',
  'growth': 'Z',
};

export const restrictedRelationships: string[] = ['FATHER', 'MOTHER'];
export const restrictedRelation: string[] = ['father', 'mother'];

export const uboOccupationDetailsMasters: string[] = [
  "PVT.SECTOR SERVICE",
  "PUBLIC SECTOR",
  "GOVT.SERVICE",
  "HOUSEWIFE",
  "DEFENCE",
  "PROFESSIONAL",
  "RETIRED",
  "BUSINESS",
  "AGRICULTURE",
  "STUDENT",
  "FOREX DEALER",
  "OTHERS",
]

export const IdentityProofsMasters: string[] = [
  'Photo PAN Card',
  'Passport',
  "Voter's ID",
  'Driving License',
  'Aadhaar Card',
];

export const uboIdentificationTypeMasters: string[] = [
  "Passport",
  "Election ID Card",
  "PAN Card",
  "ID Card",
  "Driving License",
  "UIDIA/Aadhaar Card",
  "NREGA Job Card",
  "Others",
  "Not Categorized",
  "TIN(Taxpayer Identification Number)",
  "Company Identification Number",
  "US GIIN",
  "Global Entity Identification Number",
]

export const AddressProofsMasters: string[] = [
  'Passport',
  "Voter's ID",
  'Ration Card',
  'Electricity Bill',
  'Landline/Telephone Bill',
  'Gas Bill',
  'Latest Bank Statement/Passbook',
  'Latest Depository Account Statement',
];

export const IdProofsMasters: string[] = [
  'PAN Card',
  'Aadhaar Card',
  'Driving License',
  'Passport',
];
export const idProofLabelsMasters: { [key: string]: string } = {
  'PAN Card': 'PAN Number*',
  'Aadhaar Card': 'Aadhaar Number(Last 4 Digits)*',
  'Driving License': 'Driving License Number*',
  'Passport': 'Passport Number*',
};
export const BankAccountProofsMasters: string[] = [
  'Bank Statement with IFSC printed on it',
  'Cancelled cheque leaf verified',
  'Letter from the bank giving account details',
  'Passbook (showing bank account details)',
];

export const DropDownMasters: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

export const filterApplicationTypes = [
  { key: 'individual', value: 'Individual (Resident)' },
  // { key: 'non_individual', value: 'Non-Individual' },
  // { key: 'poa', value: 'Individual (POA)' },
  { key: 'minor', value: 'Minor' },
  { key: 'nri', value: 'Individual (NRI)' },
  { key: 'non_individual', value: 'Non-Individual' },
  // { key: 'nri_poa', value: 'Individual (NRI-POA)' },
];

export const rekycStatusMapper = [
  { key: 'pending', value: 'Pending' },
  { key: 'due', value: 'Due' },
  { key: 'completed', value: 'Completed' },
  // {key:'expired', value:'Expired'}
]

export const reKycReasonmapper = [
  // { key: "risk profile expired", value: "Risk profile expired" },
  { key: "kyc expired", value: "KYC expired" },
  { key: "minor applicant became major", value: "Minor applicant became major" }
]
export const newupdatedjointholdertypes = [
  { key: 'individual', value: 'Individual (Resident)' },
  { key: 'nri', value: 'Individual (NRI)' },
];

export const ModeOfHoldingTypes = [
  { key: 'single', value: 'Single' },
  { key: 'either or survivor', value: 'Either Or Survivor' },
  { key: 'joint', value: 'Joint' },
];

export const DiyInvestor = [
  { key: "true", value: 'Yes' },
  { key: "false", value: 'No' },
]

export const KYC_VERIFICATION_METHOD: { [key: string]: string } = {
  ckyc: 'CKYC',
  digilocker: 'Digilocker',
  // aaadharxml: 'Aadhaar XML',
};

export const ADDITIONAL_KYC_DETAILS_CATEGORY: { [key: string]: string } = {
  true_nca: 'True NCA',
  profiled_nca: 'Profiled NCA',
  household_nca: 'Household NCA',
  retail_nca: 'Retail NCA',
};


export const OnboardingType = [
  { key: 'physical', value: 'Physical' },
  { key: 'digital', value: 'Digital' },
]

export const AccountType = [
  { key: 'poa', value: 'POA' },
  { key: 'executionary', value: 'Executionary' },
  { key: 'advisory', value: 'Advisory' }
]

export const BseStatusMapper = [
  { key: 'disabled', value: 'Disabled' },
  { key: 'pending', value: 'Pending' },
  { key: 'active', value: 'Active' },
  { key: 'failed', value: 'Failed' },
]

export const IMAGE_UPLOAD_FORMATS = ['image/jpeg', 'application/pdf', 'image/png', 'image/jpg'];

export const INVESTOR_IMAGE_UPLOAD_FORMATS = ['image/png', 'image/jpg', 'image/jpeg'];

export const APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  // sent_to_applicant1: 'Sent to 1st applicant',
  sent_to_applicant1: 'E-Sign Pending with Applicant 1',
  sent_to_investor: 'Sent to Investor',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'E-Sign Completed',
  rejected: 'Rejected',
};

export const POA_APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_poa_approver: 'Sent to POA approver',
  consent_sent_to_applicants: 'Consent sent to applicants',
  sent_to_amc_approver: 'Sent to Checker',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by trustee',
  invitationexpired: 'Invitation Expired',
  signed: 'E-Sign Completed',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const ESIGN_STATUS: { [key: string]: string } = {
  NOT_GENERATED: 'notgenerated',
  PENDING_SIGNATURE: 'pendingsignature',
  SIGNED: 'signed',
  EXPIRED: 'expired',
};

export enum USER_ROLES {
  SUPER_ADMIN = 'superadmin',
  AMC_ADMIN = 'amcadmin',
  RM = 'rm',
  DISTRIBUTOR = 'distributor',
  INVESTOR = 'investor',
  FUND_MANAGER = 'fundmanager',
  TRUSTEE = 'trustee',
  WITNESS = 'witness',
  APPLICATION = 'application',
  SUBDISTRIBUTOR = 'subdistributor',
  POAAPPROVER = 'poaapprover',
  AMCAPPROVER = 'amcapprover',
  AUTHORISEDSIGNATORY = 'authorisedsignatory',
  POACHECKER = 'poa_ch',
  ANALYST = "analyst",
  ONBOARDING_SPECIALIST = "onboardingspecialist",
  OPE = "ope",
  OPM = "opm"
}

export enum ROLE_TYPE {
  REX = 'REX',
  RSM = 'RSM',
  RTL = 'RTL',
  RWM = 'RWM',
  REL_M = 'REL_M',
  CLU_HEAD = 'CLU_HEAD',
  SCL_HEAD = 'SCL_HEAD',
  REG_SM = 'REG_SM',
  SREG_SM = 'SREG_SM',
  ZON_HEAD = 'ZON_HEAD',
  BUS_HEAD = 'BUS_HEAD',
}

export enum SUBROLE {
  CSO = 'CSO',
  IPS = 'IPS',
  SIPS = 'SIPS',
  SUB_BRK = 'SUB_BRK',
  ADM_CH = 'ADM_CH'
}

export enum ROLE_GROUP {
  RSP = 'RSP',
  RMR = 'RMR',
}

export const ApplicationStatusBasedOnRole: { [key: string]: { [key: string]: string } } = {
  [USER_ROLES.POAAPPROVER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_poa_approver: 'Pending',
  },
  [USER_ROLES.AMCAPPROVER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_amc_approver: 'Pending',
  },
};

export const Relations = [
  'Mother',
  'Father',
  'Daughter',
  'Son',
  'Spouse',
  'Brother',
  'Sister',
  'Others',
];

export const ContactRelations: { [key: string]: string } = {
  self: 'Self',
  spouse: 'Spouse',
  dependent_children: 'Dependent Children',
  dependent_parents: 'Dependent Parents',
  depending_siblings: 'Depending Siblings',
};

export const CurrencyMaster: { [key: string]: string } = {
  india: 'India',
  dolalr: 'US Dollar',
  euro: 'Euro',
  poundt: 'British Pound',
  other: 'Other',
};
export const NomineeRelations = [
  //   'MOTHER',
  //   'FATHER',
  //   'DAUGHTER',
  //   'SON',
  //   'SPOUSE',
  //   'BROTHER',
  //   'SISTER',
  //   'OTHERS',

  "FATHER",
  "MOTHER",
  // "HUSBAND",
  "SPOUSE",
  "GRANDFATHER",
  "GRANDMOTHER",
  "SISTER",
  "DAUGHTER",
  // "SELF",
  "BROTHER",
  "SON",
  "DAUGHTER IN LAW",
  "OTHERS"
];

export const relatedRelations = ['MOTHER', 'FATHER', 'DAUGHTER', 'SON', 'SPOUSE', 'OTHERS'];
export const relationshipsWithGuardian = ['MOTHER', 'FATHER', 'COURT APPOINTED LEGAL GUARDIAN']

export const adminSupportMaster: { [key: string]: string } = {
  unlock_user: 'Unlock User',
  check_whitelisted: 'Check Whitelisted',
  whitelist_user: 'Whitelist User',
  unwhitelist_user: 'Unwhitelist User',
  // change_expired_status: 'Change Expired Status',
  // change_status_to_draft: 'Change Status to draft',
};

export const IS_DOB_APPLICABLE_FOR_AMC = true;

export const REJECTED_ROLES: { [key: string]: string } = {
  poaapprover: 'POA Approver',
  amcapprover: 'Checker',
};

export const investorTypeMasters: { [key: string]: string } = {
  corporate: 'Corporate',
  SOLEPROP: 'Sole Proprietorship',
  trust: 'Trust',
  partnership_firm: 'Partnership Firm',
  huf: 'HUF',
  govt_bodies: 'Army/ Government Bodies',
  registered_society: 'Registered Society',
  fii_fpi: 'FII/FPI',
  bank: 'Bank',
  institutional_investor: 'Institutional Investor',
  unincorporated_or_body_of_individuals: 'Unincorporated association or a body of individuals',
  foreign_entity: 'Foreign Entity',
  company: 'Company',
  llp: 'LLP',
};
export const IS_PENNYDROP_APPLICABLE_FOR_AMC = true;

export const getGroupNameMaster = ['Group-A', 'Group-B', 'Group-C'];

export const NON_INDIVIDUAL_APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_amc_approver: 'Sent to Checker',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by trustee',
  invitationexpired: 'Invitation Expired',
  signed: 'E-Sign Completed',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const CpUboCodesMaster: { [key: string]: string } = {
  C01: '- CP of legal person-ownership',
  C02: '- CP of legal person-other means',
  C03: '- CP of legal person-senior managing official',
  C04: '- CP of legal arrangement-trust-settlor',
  C05: '- CP of legal arrangement-trust-trustee',
  C06: '- CP of legal arrangement-trust-protector',
  C07: '- CP of legal arrangement-trust-beneficiary',
  C08: '- CP of legal arrangement-trust-other',
  C09: '- CP of legal arrangement-trust-other-settlor-equivalent',
  C10: '- CP of legal arrangement-trust-other-trustee-equivalent',
  C11: '- CP of legal arrangement-trust-other-protector-equivalent',
  C12: '- CP of legal arrangement-trust-other-beneficiary-equivalent',
  C13: '- CP of legal arrangement-trust-other-other-equivalent',
  C14: '- Unknown',
};

export const uboIdentificationTypeMaster: { [key: string]: string } = {
  "Passport": "Passport",
  "Election ID Card": "Election ID Card",
  "PAN Card": "PAN Card",
  "ID Card": "ID Card",
  "Driving License": "Driving License",
  "UIDIA/Aadhaar Card": "UIDAI/Aadhaar Card",
  "NREGA Job Card": "NREGA Job Card",
  "Others": "Others",
  "Not Categorized": "Not Categorized",
  "TIN(Taxpayer Identification Number)": "TIN(Taxpayer Identification Number)",
  "Company Identification Number": "Company Identification Number",
  "US GIIN": "US GIIN",
  "Global Entity Identification Number": "Global Entity Identification Number",

}
export const controllingPersonsNationalitiesMasters: string[] = ['Indian', 'Others'];

//Application types
export enum APPLICATION_TYPE {
  INDIVIDUAL = 'individual',
  NON_INDIVIDUAL = 'non_individual',
}

export const AMC_APPROVER_CHECK_FOR_INDIVIDUAL = true;

export const ENABLE_EMAIL_OTP = true;

export const COMMENT_ROLES: { [key: string]: string } = {
  rm: 'RM',
  distributor: 'Distributor',
  subdistributor: 'Sub Distributor',
  amcapprover: 'Checker',
  investor: 'Investor',
  rex: 'REX',
  rsm: 'RSM',
  rtl: 'RTL',
  rwm: 'RWM',
};

export const APPLICATION_STATUS_AMCAPPROVER_individual: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_amc_approver: 'Sent to Checker',
  sent_to_investor: 'Sent to Investor',
  // sent_to_applicant1: 'Sent to 1st applicant',
  consent_sent_to_applicants: 'Consent sent to Applicants',
  sent_to_applicant1: 'E-Sign Pending with Applicant 1',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'E-Sign Completed',
  rejected: 'Rejected',
};
export const IndividualApplicationStatusBasedOnRole: { [key: string]: { [key: string]: string } } =
{
  [USER_ROLES.AMCAPPROVER]: {
    ...APPLICATION_STATUS_AMCAPPROVER_individual,
    sent_to_amc_approver: 'Pending',
  },
};

export const APPLICATION_LISTING_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  // sent_to_applicant1: 'Sent to 1st applicant',
  sent_to_applicant1: 'E-Sign pending with Applicant 1',
  sent_to_investor: 'Sent to Investor',
  consent_sent_to_applicants: 'Consent sent to applicants',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'E-Sign Completed',
  rejected: 'Rejected',
  sent_to_poa_approver: 'Sent to POA approver',
  sent_to_amc_approver: 'Sent to Checker',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
};
export const APPLICATION_OTP_CONSENT_STATUS: { [key: string]: string } = {
  pending: 'Pending',
  verified: 'Verified',
  // pending: 'Pending',
  // completed: 'Completed',
}
export const APPLICATION_RE_KYC_STATUS: { [key: string]: string } = {
  due: 'Due',
  expired: 'Expired',
  pending: 'Pending',
  completed: 'Completed',
  pending_from_mpower: 'Pending from MPower',
}

export const TCL_ONBOARDING_TYPE: { [key: string]: string } = {
  osv: 'OSV',
  investor: 'KYC by Investor',
  digilocker: 'Digilocker',
  aadharXml: 'Aadhaar XML',
  ckyc: 'CKYC',
}

export enum APPLICATION_TYPE_FOR_DOCUMENTS {
  INDIVIDUAL = 'individual',
  NON_INDIVIDUAL = 'non_individual',
  INDIVIDUAL_POA = 'individual_poa',
  NRI = 'nri',
  NRI_POA = 'nri_poa',
  NOMINEE_DOC = 'nominee',
  NOMINEE_GUARDIAN = 'nomineeGuardian',
  MINOR = 'minor',
  MINOR_NRI = 'minor_nri',
}
export const BankAccountTypeMaster: { [key: string]: string } = {
  Current: 'CURRENT',
  Savings: 'SAVING',
};

export const POABankAccountTypeMaster: { [key: string]: string } = {
  Current: 'CURRENT',
  Savings: 'SAVING',
  "Current POA": 'CURRENTPOA',
};

export const NRIBankAccountTypeMaster: { [key: string]: string } = {
  NRE: 'NRE',
  NRO: 'NRO',
};

export const POANRIBankAccountTypeMaster: { [key: string]: string } = {
  NRE: 'NRE',
  NRO: 'NRO',
  "CURRENT POA": 'CURRENTPOA',
};
export const DistributorTypesForUserManageMent: { [key: string]: string } = {
  Individual: 'individual',
  Company: 'company',
};

export const ENABLE_KRA_DOCUMENT_FETCH = false;

export const SALT = 'F2lNZWFxUH';
export const SALT2 = 'WTVPJel6dTGVocF';



export const ONBOARDING_OPTIONS: { [key: string]: string } = {
  otp: 'Verify via OTP',
  email_consent: 'Email Consent',
};

export const ONBOARDING_VIA_OPTIONS: { [key: string]: string } = {
  physical: 'Physical',
  digital: 'Digital',
};

export const EmailConsentStatusMaster: { [key: string]: string } = {
  pending: 'Pending',
  rejected: 'Rejected',
  approved: 'Approved',
  revoked: 'Revoked',
};

export const ENABLE_Email_Consent = true;

export const BloodRelations = ['Father', 'Mother', 'Son', 'Daughter', 'Spouse'];

export const BSEConsentMaster: { [key: string]: string } = {
  true: 'Yes',
  false: 'No',
};

export const BseClientActivationStatusMaster: { [key: string]: string } = {
  pending: 'BSE Client Activation Pending',
  active: 'BSE Client Activated',
};

export const BseClientActivationStatusMasterShort: { [key: string]: string } = {
  pending: 'Pending',
  active: 'Active',
  failed: 'Failed',
};

export const SUPPORT_STATUS: { [key: string]: string } = {
  sent_to_applicant1: 'Sent to applicant(s)',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_fundmanager: 'Approved by investment manager',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
};

export const RoleTypes: { [key: string]: string } = {
  amc_rm: 'AMC',
  support_rm: 'Service',
};

export const HELDAWAY_PORTFOLIO_STATUS = "Transactions not allowed for Heldaway Portfolios."

export const currencyCodeMap: { [key: string]: string } = {
  'inr': "Rupees",
  'php': "Peso"
}

export const WEEKLYDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const WEB_NAME = 'Aditya Birla Capital Limited';

export const MPOWER_ACCOUNT_TYPE_MASTER: { [key: string]: string } = {
  POA: "POA",
  EXY: "EXECUTIONARY",
  ADV: "ADVISORY",
  EXECUTIONARY: "EXECUTIONARY",
  ADVISORY: "ADVISORY"
}

export const ENABLE_DIY_INVESTOR_ONBOARDING = false
export const ENABLE_ORDER_MANAGEMENT = true
export const ENABLE_PAYMENT_CHECKER = true
export const PHYSICAL_DIGITAL_FLOW = true
export const ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD = true

export const PAYMENT_LOOPBACK_URL = "https://nexedgewms.kfintech.com/bsetrade" // now made dynamic with --> const LOOPBACKURL = `${window.location.origin}/bsetrade`

export const CYBER_ARC_REDIRECT_URI = "https://rm.wealth.uatwealth.com/cyberarc-callback"; //call back route from the cyberArc please dont change 

export const ORDER_ENTRY_SETTLEMENT_METHOD_CODE: { [key: string]: string } = {
  "Online Transfer": "0",
  "Client Offline Transfer": "1",
  "Initiate Transfer": "2",
};

export const REQUESTED_REPORTS: { [key: string]: string } = {
  1: "Title",
  3: "Executive Summary",
  4: "Family Portfolio Overview",
  5: "Portfolio Summary",
  6: "Portfolio Cashflow Summary",
  7: "Portfolio Highlights: Monthly Movements",
  8: "Holding Reports",
  16: "Transaction Reports- MFs",
  21: "Portfolio Attributes- Equity",
  22: "Portfolio Attributes- Fixed Income",
  23: "Asset Management Concentration",
  24: "Concentration Analysis",
  25: "Portfolio Liquidity Analysis",
  26: "IPS Frameworks/ Guidelines",
  27: "Top 10 Equity Mutual Fund Holding Overlap",
  28: "Annexure1",
  29: "Annexure2"
}

export const REQUESTED_REPORTS_KEYS: string[] = ['1', '2', '3', '4', '5', '6']

export const BSE_PAYMENT_FLOW = true
export const ONBOARDING_KYC_VERIFIED_MESSAGE = false
export const ONBOARDING_DOWNLOAD_APPLICATIONS_IGNORE_STATUS_CHECK = true
export const DOCUMENT_UPLOAD_DOWNLOAD_APPLICATION = true
export const ONBOARDING_DEMAT_DETAILS = false
export const NEXEDGE_INVESTMENT_PREFERENCE = false
export const NEXEDGE_MDMS_APIS = true


export const ADDITIONAL_DETAILS_FAMILY_MEMBER_LIMIT = 6;
export const NOMINEE_DETAILS_NOMINEE_LIMIT = 3

export const CONTENT_TYPE = {
  PDF: "application/pdf",
  EXCEL: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  CHEQUE_RESPONSE: "application/pdf"
}

export const INDIVIDUAL_ONBOARDING_CHAR_LIMIT = {
  PERSONAL_DETAILS: {
    FIRST_NAME: 70,
    LAST_NAME: 70,
    FULL_NAME: 70
  }
}
export const MINOR_ONBOARDING_CHAR_LIMIT = {
  PERSONAL_DETAILS: {
    GUARDIAN_FIRST_NAME: 120,
    GUARDIAN_LAST_NAME: 120,
    GUARDIAN_FULL_NAME: 120,
    MINOR_FIRST_NAME: 70,
    MINOR_LAST_NAME: 70,
    MINOR_FULL_NAME: 70
  }
}

export const NON_INDIVIDUAL_ONBOARDING_CHAR_LIMIT = {
  CONTRIBUTOR_DETAILS: {
    NAME_OF_ENTITY: 70
  }
}

export const MAX_SCHEMES_SELECTED = 10

export function getDigiLockerErrorMessage(errorCode?: string): string {
  if (!errorCode) return 'An unknown error occurred. Please try again.';

  switch (errorCode) {
    case 'access_denied':
      return 'You denied the request or canceled the DigiLocker login. Please try again if you wish to continue.';

    case 'invalid_request':
      return 'There was a problem with the request sent to DigiLocker. Please contact support or try again later.';

    case 'server_error':
      return 'DigiLocker encountered an internal error. Please try again after some time.';

    case 'temporarily_unavailable':
      return 'DigiLocker services are temporarily unavailable. Please wait a few moments and try again.';

    default:
      return `An unexpected error occurred: ${errorCode}`;
  }
}


export const RISKPROFILE_APPLICATION_TYPE_MAP = {
  individual: 'INDIVIDUAL',
  non_individual: 'CORPORATE',
};

export const DIGITAL_KYC_DOCS = [
  'bankAccountProof',
  'investorPhotograph',
  'investorSignature',
  "form_10ff_trc",
  "additional",
  "pioCard",
  "overseaseAddressProof",
  "passportCopy",
  "physical_signed_document",
  'court_proof_of_guardian',
  'dateOfBirthProof',
  'nominee_opt_out',
  'additional'
];

export const ALWAYS_SHOW_DOCS = [
  'nominee_opt_out'
]

export const ADDRESS_SAME_DOCS = [
  'correspondenceAddress',
]

export const REPORTS_FILTER_TYPE_OPTIONS: Array<{ key: string; value: string; isDisabled?: boolean }> = [
  { key: "CLIENT", value: "CUSTOMER", isDisabled: false },
  { key: "PORTFOLIO", value: "PORTFOLIO", isDisabled: false },
  { key: "FAMILY", value: "FAMILY", isDisabled: false },
]

export const COMMON_EDIT = true;


export const TRANSACTION_TYPE = {
  REDEMPTION: "REDEMPTION",
  PURCHASE: "PURCHASE"
}

export const ONBOARDING_SUB_TYPE_NON_INDIVIDUAL: { [key: string]: string } = {
  normal: "Normal",
  proprietary: "Proprietary",
}

export const ONBOARDING_SUB_TYPE_MINOR: { [key: string]: string } = {
  normal: "Resident",
  nri: "NRI",
}

export const ONBOARDING_TYPE_MAPPER: { [key: string]: string } = {
  minor: "minor",
  individual: "individual",
  nonIndividual: "non_individual",
}

export const UPI_LIMIT = 500000

export const fundTypes: Array<{ label: string; value: boolean }> = [
  { label: 'ALL product', value: true },
  { label: 'Non MF Product', value: false }
]

export const PHYSICAL_MANDATE_STATUS_KEY_NOT_UPLOADED = 'SCAN IMAGE NOT UPLOADED';

export const NON_MF_FUNDS_FILTER: Array<{ label: string; value: string }> = [
  { label: 'ALL', value: 'ALL' },
  { label: 'External Transactions', value: 'TRADE_DATA' },
  { label: 'Corporate Actions', value: 'BENEFIT_DATA' },
  { label: 'Miscellaneous Transactions', value: 'MISC_DATA' }
]

export const ADD_UBO_EXCEPTION = ['huf', 'soleprop']

export const NOTIFICATIONS_LIMIT = 3

export const LIST_OF_BANKS = "https://www.npci.org.in/product/nach/all-members";

export const NOTIFICATIONS_CATEGORY = [
  { label: "Next KYC Date", id: "NEXT_KYC_DATE" },
  { label: "Minor to Major", id: "MINOR_TO_MAJOR" },
  { label: "OVD Not Received", id: "OVD_NOT_RECEIVED" },
  { label: "Document Expired", id: "DOC_EXPIRED" },
  { label: "Transactions", id: "ORDER" },
]

export const NO_DATA_ERROR_MESSAGE = 'No Data Found or Available';

export const NO_DATA_ERROR_MESSAGE_TRANSACTION = 'No Data Found or Available In Last 30 Days';


export const showGoalCalculator = false

export const NOMINEE_DISCLAIMER = ''

export const NO_NOMINEE_DISCLAIMER = 'I / We hereby confirm that I / We do not wish to appoint any nominee(s) for my mutual fund units held in my / our mutual fund folio and understand the issues involved in non-appointment of nominee(s) and further are aware that in case of death of all the account holder(s), my / our legal heirs would need to submit all the requisite documents issued by Court or other such competent authority, based on the value of assets held in the mutual fund folio.';

export const DISABLE_NOMINEE_OPY_OUT = false;

export const DISABLESIPDATE = 45;

export const SWP_FIRST_ORDER_FLAG_LABEL = "Withdraw 1st Installment Today"

export const STP_FIRST_ORDER_FLAG_LABEL = "Transfer 1st Installment Today"

export const PAYMENT_NOTE = "If payment already initiated please wait for BSE to confirm the payment";

export const yearfor125years = 125;

export const eighteenYearsAgoDate = 18;

export const yearfor156years = 156;  //nonindividual allows 156 before

export const NO_BANKS_ADDED = "No Banks Have Been Added"

export const EITHER_OR_SURVIVOR = "This action will create a joint account and require OTP verification from the joint holder for transactions.";

export const ASL_EXCEPTION = ['soleprop']

export const REDEEM_TO_DEFAULT_ACCOUNT = "Initially selected account is the Default Bank Account. All payouts will be credited to this account.";

export const CHEQUE_HDFC_BANK = "HDFC BANK";

export const CHEQUE_MESSAGE = "Your Transaction Has Been Done Through Payment Mode Cheque Successfully!!"

export const RISK_PROFILE_SOLEPROP = "SOLEPROP"

export const INV_MAND_SWITCH = "If you have Created New Mandate. Please complete the Mandate Authentication."

export const RM_MAND_SWITCH = "In case of New Mandate, please ensure Mandate Authentication with Investor."
